import { debounce } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react'

import { getAllStaff } from '../../../actions/Team/team.actions'
import { TeamTable } from '../../../components/Tables/TeamTable'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: '#FFFFFF'
	}
}))

const Team = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const staffList = useSelector((state) => state.specific.team.staffList)

	const [search, setSearch] = useState('')

	const delayeOnSearchChange = useRef(
		debounce((s, sb) => {
			setSearch(s)
		}, 750)
	).current

	useEffect(() => {
		dispatch(getAllStaff())
		dispatch({ type: 'CLEAR_SELECTED_STAFF' })
	}, [])

	useEffect(() => {
		if (search) {
			dispatch(getAllStaff())
		}
	}, [search])

	return (
		<div className={classes.root}>
			<div className={classes.visitsTableContainer}>
				<TeamTable staffList={staffList} onSearchChange={delayeOnSearchChange} />
			</div>
		</div>
	)
}

export default Team
